
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from "firebase/firestore";
import {getAuth,signInWithPopup,GoogleAuthProvider} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAnn5gHJJH9O4PJY7zvSgUZbEwAEj8Pz9Q",
  authDomain: "whatsapp-clone-59e82.firebaseapp.com",
  projectId: "whatsapp-clone-59e82",
  storageBucket: "whatsapp-clone-59e82.appspot.com",
  messagingSenderId: "642802391318",
  appId: "1:642802391318:web:17aaf292be986da7215837",
  measurementId: "G-CE3N4Q9SQ6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const provider=new GoogleAuthProvider();

export const auth = getAuth(app);

export default getFirestore();